<script>
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import MdmForm from '@client/pages/staff/domains/modals/forms/mdm-form.svelte';

  import { UsersService } from '@client/services/users';

  import { appStore } from '@client/stores/app';

  const { addNotification } = getNotificationsContext();

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  let formRef;
  let error = '';
  let initializing = false;

  let users = '';
  let selectedDomains = [];
  let actionItem = null;
  let authcode = '';

  const executeMdmUpdate = async () => {
    const mdmdomains = selectedDomains.map(({ value }) => value).join('\n');
    const action = actionItem.value;
    const payload = {
      mdmusers: users,
      mdmdomains,
      authcode
    };

    error = '';

    $appStore.loading = true;

    let response = null;

    if (action === 'assign') {
      response = await UsersService.assignUsersMDM(payload);
    } else {
      response = await UsersService.unassignUsersMDM(payload);
    }

    $appStore.loading = false;

    if (response.status && response.status !== 200) {
      error = $format('label.FAILURE.MDM_UPDATE', {
        values: {
          verb: action,
          users: users.replace(/\n/g, ','),
          domains: mdmdomains.replace(/\n/g, ','),
          message: response.message
        }
      });

      throw new Error(response.message);
    }

    addNotification({
      text: $format('label.SUCCESS.MDM_UPDATE', { values: { verb: action } }),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    step.data = {
      id: mdmdomains.replace(/\n/g, ', ')
    };

    return response;
  };

  $: if (onExecute !== null) {
    onExecute(executeMdmUpdate);
  }

  $: if (onRollback !== null) {
    onRollback(null);
  }

  $: nextDisabled = selectedDomains === undefined || !users || !actionItem || !authcode;
</script>

<MdmForm bind:this={formRef} bind:users bind:selectedDomains bind:actionItem bind:authcode bind:initializing {error} />
